import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-5b0a8c44")
const _hoisted_1 = { class: "button" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("mdi-upload")
const _hoisted_3 = ["innerHTML"]
_popScopeId()

import { withDefaults, ref, onMounted } from 'vue'
import { AxiosInstance } from 'axios'
import Action from '@/components/Dialog/enums/DialogAction'
import TheDialog from '@/components/Dialog/TheDialog.vue'
import { IAutomation } from '@/interfaces/hoppermation'
import createAuth0APIClient from '@/clients/hoppermation'
import bus from '@/lib/eventBus'
import EventNames from '@/lib/enums/eventNames'

interface IProps {
  automation?: IAutomation
}


export default /*#__PURE__*/_defineComponent({
  props: {
    automation: { type: null, required: false, default: () => ({} as IAutomation) }
  },
  setup(__props: any) {

const props = __props as { automation: IAutomation }


const hoppermationApiClient = ref({} as AxiosInstance)

onMounted(async () => {
  hoppermationApiClient.value = await createAuth0APIClient()
})

const importData = ref({})
const action = Action.CONFIRM

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const onFileChange = (e: any) => {
  const files = e?.target.files || e.dataTransfer.files
  if (!files.length) return
  let reader = new FileReader()
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  reader.onload = (e: any) => {
    importData.value = JSON.parse(e.target.result)
  }
  reader.readAsText(files[0])
}

const onSubmit = async () => {
  try {
    await hoppermationApiClient.value.post(`/automations/${props.automation.id}/ui-steps`, importData.value)
    bus.$emit(EventNames.SHOW_SNACKBAR, { color: 'success', text: 'snackbar.automation.save.success' })
  } catch (error) {
    bus.$emit(EventNames.SHOW_SNACKBAR, { color: 'error', text: 'snackbar.automation.save.error' })
    return false
  }
  return true
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createBlock(TheDialog, {
    action: _unref(action),
    title: _ctx.$t('dialog.import.title'),
    imageSrc: "https://assets6.lottiefiles.com/packages/lf20_0bdyigel.json",
    submit: onSubmit
  }, {
    activator: _withCtx(({ props }) => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_icon, _mergeProps({
          size: "small",
          class: "mr-5"
        }, props), {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 2
        }, 1040)
      ])
    ]),
    content: _withCtx(() => [
      _createElementVNode("p", {
        class: "mb-4 text-subtitle",
        innerHTML: _ctx.$t('dialog.import.desc')
      }, null, 8, _hoisted_3),
      _createElementVNode("input", {
        type: "file",
        accept: "application/json",
        onChange: onFileChange
      }, null, 32)
    ]),
    _: 1
  }, 8, ["action", "title"]))
}
}

})